// Dialog async of Excel
import { urlAuth } from '../../constants/env'

export const openAuthenticationDialog = async (callback, permission) => {
    const url_auth = permission ? `${urlAuth}?permission=true` : urlAuth
    console.log('[Auth:Addin] openAuthenticationDialog called, url_auth:', url_auth)
    await window.Office.context.ui.displayDialogAsync(url_auth, { height: 40, width: 30, requireHTTPS: true }, (result) => {
        console.log('[Auth:Addin] displayDialogAsync result:', result)
        const loginDialog = result.value
        loginDialog.addEventHandler(window.Office.EventType.DialogMessageReceived, (arg) => {
            console.log('[Auth:Addin] DialogMessageReceived raw arg.message:', arg.message)
            const msgFromDialog = JSON.parse(arg.message)
            console.log('[Auth:Addin] parsed msgFromDialog:', msgFromDialog)
            if (msgFromDialog.success) {
                console.log('[Auth:Addin] success=true, token field:', msgFromDialog.token)
                loginDialog.close()
                if (callback)
                    callback(msgFromDialog.token)
            } else if (msgFromDialog.error || msgFromDialog.msg) {
                loginDialog.close()
                console.log("Unable to authenticate user: " + JSON.stringify(msgFromDialog))
                if (callback)
                    callback(null)
            }
        })
    })
}

export const getFileFromUrl = () => {
    // Decoded copy for deriving readable fileName/path segments below.
    const urlFile = decodeURIComponent(window?.Office?.context?.document?.url || '')
    const fileProps = {
        fileName: "",
        path: "",
        // The backend resolves webUrl through the Graph Shares API, which only
        // accepts a properly encoded url. Office on desktop reports the url
        // already decoded (raw spaces), so re-encode the decoded copy instead
        // of trusting Office's form (this also avoids double-encoding).
        webUrl: encodeURI(urlFile)
    }
    const checkUrl = urlFile.split('d.docs.live.net')
    if (checkUrl.length !== 1) {
        // Personal OneDrive (consumer): the library name is implicit in the
        // d.docs.live.net url, so we normalize the first segment to "Documents".
        let FilePath = checkUrl[1].split('/')
        FilePath.shift()
        FilePath[0] = "Documents"
        FilePath = FilePath.join('/')
        const Path = FilePath.split('/')
        const FileName = Path.pop()
        const PathAddress = Path.join('/')
        fileProps.fileName = FileName.replace(/\^J/gi, ",")
        fileProps.path = PathAddress
    } else {
        // SharePoint / OneDrive for Business. We must NOT anchor on the literal
        // word "Documents": localized tenants name the library differently
        // (e.g. Dutch "Gedeelde documenten"), which previously collapsed the
        // path and produced fileName="x", path="". Instead, parse the url
        // structurally: drop the site-collection prefix and keep everything
        // from the document library onward.
        //
        // Note: avoid `new URL()` — this app targets IE 11 where it's missing.
        const pathname = urlFile
            .replace(/^https?:\/\/[^/]+/i, '')
            .split('?')[0]
        let segments = pathname.split('/').filter(Boolean)
        // e.g. "/sites/Finance/...", "/teams/X/...", "/personal/user/..."
        if (['sites', 'teams', 'personal'].indexOf(segments[0]) !== -1) {
            segments = segments.slice(2)
        }
        const FileName = segments.pop() || ''
        const PathAddress = segments.join('/')
        fileProps.fileName = FileName.replace(/\^J/gi, ",")
        fileProps.path = PathAddress
    }
    return fileProps
}

export const checkLocalUrl = () => {
    // Check if is a local file
    let isLocalFile = null
    try {
        const fileURL = window.Office.context.document.url
        isLocalFile = fileURL.split('/').find(path => path === 'https:')
    } catch (e) {
        console.log(e)
        isLocalFile = true
    }
    
    return (!isLocalFile)
}